
<template>
  <div>
    <Header />
    <div id="app">
      <div class="content-web container mt-5">
        <!-- Modal Delete -->
        <div
          class="modal fade"
          id="deleteSubmision"
          tabindex="-2"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="deleteSubmisionLabel">Xóa sáng kiến</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">Bạn có chắc muốn xóa sáng kiến này?</div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="clearComboBoxUser()"
                >Hủy</button>

                <button
                  @click="deleteSubmission(tempId)"
                  type="button"
                  class="btn btn-info"
                  data-dismiss="modal"
                >Đồng ý</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal Assign -->
        <div
          class="modal fade"
          id="assignReviewerModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="assignReviewerModalLabel"
          aria-hidden="true"
          data-keyboard="false"
          data-backdrop="static"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title required" id="assignReviewerModalLabel">Nội dung chỉ định</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-4">
                    <div
                      for="recipient-name"
                      class="col-form-label lbl-edit-role required"
                    >Tên người đánh giá:</div>
                  </div>
                  <div class="col-md-8">
                    <v-select
                      id="review-submission-reviewer"
                      label="account"
                      placeholder="Select"
                      :options="reviewer"
                      v-model="comboBox.reviewerAss"
                      multiple
                    ></v-select>
                    <div class="error1 errortemp">
                      <i class="fa fa-exclamation-circle" aria-hidden="true"></i> Không được để trống.
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="clearComboBoxUser()"
                >Hủy</button>
                <button
                  id="btn-save"
                  type="button"
                  class="btn btn-info"
                  @click="insertAssignedReviewer(tempId)"
                >Lưu</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Filter -->
        <div class="col-12 search-box mb-5 clearfix" id="search">
          <div class="row">
            <div class="col-12">
              <label class="title">Bộ lọc:</label>
            </div>
          </div>

          <div class="row">
            <div class="col-12 d-flex mr-2 mb-2">
              <input
                v-model="ipSearchForm.title"
                class="form-control mr-2 mb-2"
                type="text"
                placeholder="Tiêu đề"
                v-on:keyup.enter="searchSubmission(true)"
              />
              <input
                v-model="ipSearchForm.author"
                class="form-control mr-2 mb-2"
                type="text"
                placeholder="Tác giả"
                v-on:keyup.enter="searchSubmission(true)"
              />
              <input
                v-model="ipSearchForm.contactEmail"
                class="form-control mr-2 mb-2"
                type="text"
                placeholder="Email"
                v-on:keyup.enter="searchSubmission(true)"
              />              
              <v-select
                class="v-select-option mr-2 mb-2"
                label="name"
                placeholder="Lĩnh vực: Tất cả"
                :options="listType"
                v-model="ipSearchForm.type"
                :reduce="p => p.code"
              ></v-select>
              <v-select
                class="v-select-option mr-2 mb-2"
                label="name"
                placeholder="CTTV: Tất cả"
                :options="companys"
                :reduce="p => p.code"
                v-model="comboBox.companyCode"
              ></v-select>
              <v-select
                class="v-select-option mr-2 mb-2"
                label="name"
                placeholder="Trạng thái: Tất cả"
                :options="listStatus"
                :reduce="obj => obj.code"
                v-model="ipSearchForm.status"
              ></v-select>

              <!-- new modal -->
              <!-- Button trigger modal -->
              <!-- <button
                class="btn dropdown-toggle mr-2 mb-2"
                type="button"
                data-target="#dateSearch"
                data-toggle="modal"
              >{{displayDate}}</button>-->

              <div
                class="modal fade"
                id="dateSearch"
                tabindex="-1"
                role="dialog"
                aria-labelledby="dateSearchModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-lg modal-md" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="dateSearchModalLabel">Lựa chọn ngày tìm kiếm</h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <!-- Submited Date -->
                      <div class="row">
                        <div class="col-lg-3 col-md-12 col-sm-12">
                          <div class="form-check form-check-inline radio_value mr-0">
                            <input
                              class="form-check-input mb-2"
                              @click="clearDate(),checkDate='submit';displayDate='Submiited Date'"
                              type="radio"
                              name="search-date"
                              id="submitedDate"
                            />
                            <label
                              class="form-check-label mb-2 mr-2 sm"
                              for="submitedDate"
                            >Ngày submited</label>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6">
                          <date-picker
                            class="date-control mr-2 mb-2"
                            @input="displayDateSearch()"
                            placeholder="From Date"
                            type="date"
                            v-model="ipSearchForm.submitedTimeFrom"
                            v-on:keyup.enter="searchIpReuse(true)"
                            :disabled="checkDate!=='submit'"
                            :disabled-date="disabledSubmitedTimeFrom"
                          ></date-picker>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6">
                          <date-picker
                            class="date-control mr-2 mb-2"
                            @input="displayDateSearch()"
                            placeholder="To Date"
                            type="date"
                            v-model="ipSearchForm.submitedTimeTo"
                            v-on:keyup.enter="searchIpReuse(true)"
                            :disabled="checkDate!=='submit'"
                            :disabled-date="disabledSubmitedTimeTo"
                          ></date-picker>
                        </div>
                      </div>

                      <!-- Assigned Date -->
                      <div class="row">
                        <div class="col-lg-3 col-md-12 col-sm-12">
                          <div class="form-check form-check-inline radio_value mr-0">
                            <input
                              class="form-check-input mb-2"
                              @click="clearDate(),checkDate='ass';displayDate='Assign Date'"
                              type="radio"
                              name="search-date"
                              id="assignedDate"
                            />
                            <label
                              class="form-check-label mb-2 mr-2 sm"
                              for="assignedDate"
                            >Assigned Date</label>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6">
                          <date-picker
                            class="date-control mr-2 mb-2"
                            @input="displayDateSearch()"
                            placeholder="From Date"
                            type="date"
                            v-model="ipSearchForm.assignedDateFrom"
                            v-on:keyup.enter="searchIpReuse(true)"
                            :disabled="checkDate!=='ass'"
                            :disabled-date="disabledAssignedDateFrom"
                          ></date-picker>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6">
                          <date-picker
                            class="date-control mr-2 mb-2"
                            @input="displayDateSearch()"
                            placeholder="To Date"
                            type="date"
                            v-model="ipSearchForm.assignedDateTo"
                            v-on:keyup.enter="searchIpReuse(true)"
                            :disabled="checkDate!=='ass'"
                            :disabled-date="disabledAssignedDateTo"
                          ></date-picker>
                        </div>
                      </div>

                      <!-- Published Time -->
                      <div class="row">
                        <div class="col-lg-3 col-md-12 col-sm-12">
                          <div class="form-check form-check-inline radio_value mr-0">
                            <input
                              class="form-check-input mb-2"
                              @click="clearDate(),checkDate='publish';displayDate='Publish Date'"
                              type="radio"
                              name="search-date"
                              id="publishedTime"
                            />
                            <label
                              class="form-check-label mb-2 mr-2 sm"
                              for="publishedTime"
                            >Published Time</label>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6">
                          <date-picker
                            class="date-control mr-2 mb-2"
                            @input="displayDateSearch()"
                            placeholder="From Date"
                            type="date"
                            v-model="ipSearchForm.publishedTimeFrom"
                            v-on:keyup.enter="searchIpReuse(true)"
                            :disabled="checkDate!=='publish'"
                            :disabled-date="disabledPublishedTimeFrom"
                          ></date-picker>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6">
                          <date-picker
                            class="date-control mr-2 mb-2"
                            @input="displayDateSearch()"
                            placeholder="To Date"
                            type="date"
                            v-model="ipSearchForm.publishedTimeTo"
                            v-on:keyup.enter="searchIpReuse(true)"
                            :disabled="checkDate!=='publish'"
                            :disabled-date="disabledPublishedTimeTo"
                          ></date-picker>
                        </div>
                      </div>

                      <!-- All -->
                      <div class="row">
                        <div class="col-lg-3 col-md-12 col-sm-12">
                          <div class="form-check form-check-inline radio_value mr-0">
                            <input
                              class="form-check-input mb-2"
                              type="radio"
                              name="search-date"
                              id="allTime"
                              @click="clearDate()"
                              value="all"
                              v-model="allDate"
                            />
                            <label class="form-check-label mb-2 mr-2 sm" for="allTime">All Date</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn_control"
                        data-dismiss="modal"
                        @click="hideDateSearch"
                      >Đóng</button>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <button
                  class="btn btn_control mr-1 mb-2"
                  v-on:click="searchSubmission(true)"
                >Tìm kiếm</button>
                <button
                  type="submit"
                  class="btn btn_control mr-1 mb-2"
                  v-on:click="clearFilterSearch(),clearDate()"
                >Xóa</button>
                <!-- <button
                  type="submit"
                  class="btn btn_control mr-1 mb-2"
                  v-on:click="exportReviewSubmissionExcel()"
                >
                  <span
                    v-if="loadingExport"
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Xuất file
                </button>-->
              </div>
            </div>
          </div>
        </div>

        <!-- Loading -->
        <div class="table-box list-grid mb-5" v-if="loading">
          <div class="text-center">
            <div class="spinner-border text-dark" role="status">
              <span class="sr-only">Đang tải...</span>
            </div>
          </div>
        </div>

        <!-- Table -->
        <div v-else class="table-box list-grid mb-5">
          <div class="title">
            <h6>DUYỆT SÁNG KIẾN</h6>
          </div>
          <div class="content-table">
            <table
              class="table table-hover table-md"
              style="overflow: inherit; table-layout: fixed;"
            >
              <thead>
                <tr style=" text-align:top;">
                  <th style="width: 60px;">ID</th>
                  <th style="width: 180px;">TIÊU ĐỀ</th>
                  <th style="width: 180px;">GIỚI THIỆU NGẮN GỌN</th>
                  <th style="width: 110px;">TRẠNG THÁI</th>
                  <th style="width: 120px;">LĨNH VỰC</th>
                  <th style="width: 120px;">TÁC GIẢ/ NHÓM TÁC GIẢ</th>
                  <th style="width: 100px;">TẠO BỞI</th>
                  <th style="width: 100px;">THỜI GIAN ĐK</th>
                  <th style="width: 100px;">CTTV</th>
                </tr>
              </thead>
              <tbody>
                <tr class="cell" v-for="item in submission" v-bind:key="item.id">
                  <td>{{item.id}}</td>
                  <td style="word-break: break-word;">
                    <a v-bind:href="`${ipDetailUrl}/${item.id}`">{{item.title}}</a>
                  </td>
                  <td style="word-break: break-word;">{{item.summary}}</td>
                  <td style="word-break: break-word;">{{item.statusName}}</td>
                  <td style="word-break: break-word;">{{item.type | getTypeName}}</td>
                  <td style="word-break: break-word;">{{item.author}}</td>
                  <td style="word-break: break-word;">{{item.createdBy}}</td>
                  <td>{{item.createdTime | date}}</td>
                  <td>{{item.companyName}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row mt-4 pagination">
            <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 pagesize">
              <span
                v-if="((pageSize*pageIndex)>total&&total!=0)"
              >{{pageSize*(pageIndex-1)+1}}-{{total}} của {{total}}</span>
              <span
                v-if="((pageSize*pageIndex)<=total)&&total!=0"
              >{{pageSize*(pageIndex-1)+1}}-{{pageSize*pageIndex}} của {{total}}</span>
              <span v-if="total==0">0-0 của 0</span>
            </div>
            <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 d-flex justify-content-end pageindex">
              <b-pagination
                v-if="total > pageSize"
                v-model="pageIndex"
                pills
                :total-rows="total"
                :per-page="pageSize"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
import departmentCommon from "../../common/department";
import axios from "axios";
import masterDataCommon from "../../common/masterData";
import moment from "moment";
import { BPagination } from "bootstrap-vue";
import * as CONFIG from "../../config/index";
import helper from "../../common/helper";
import { ipType } from "../const/ipType";
import ideaCommon from "../../common/idea";

export default {
  name: "ReviewSubmission",
  components: {
    Header,
    Footer,
    "b-pagination": BPagination,
    DatePicker
  },
  data() {
    return {
      ipSearchForm: {
        author: "",
        submitedTimeFrom: "",
        submitedTimeTo: "",
        publishedTimeFrom: "",
        publishedTimeTo: "",
        title: "",
        assignedDateFrom: "",
        assignedDateTo: "",
        reviewer: "",
        ipType: "",
        typeName: "",
        companyCode: "",
        status: "",
        contactEmail:"",
      },
      tempId: "",
      pageIndex: 1,
      pageSize: 20,
      comboBox: {
        reviewerAss: null,
        reviewer: null,
        ipType: null,
        companyCode: null,
        status: null
      },

      masterData: {
        type: [],
        status: []
      },
      message: {
        delete: null,
        assign: null
      },
      total: 0,
      companys: [],
      reviewer: [],
      submission: null,
      tempReviewer: null,
      allDate: "all",
      checkDate: "",
      displayDate: "Date Search",
      ipDetailUrl: `${CONFIG.CLIENT_URL}/#/admin/ip-view`,
      editSubmissionUrl: `${CONFIG.CLIENT_URL}/#/admin/edit-submission`,
      dismisModal: "",
      loading: false,
      screenCode: CONFIG.SCREEN_CODE.REVIEW_SUBMISSION,
      isDisplayBtn: false,
      loadingExport: false,
      searchForm: {
        title: "",
        author: "",
        createdBy: "",
        companyCode: "",
        status: ""
      },
      listStatus: [],
      listType: []
    };
  },
  filters: {
    getTypeName(code) {
      if (!code) {
        return "";
      }
      const typeData = ipType.find(p => p.code === code);
      if (typeData) {
        return typeData.name;
      }
      return "";
    },
    date: function(date) {
      return moment(date).format("YYYY-MM-DD");
    }
  },
  watch: {
    pageIndex: {
      immediate: false,
      async handler(newVal, oldVal) {
        let listSubmission = await ideaCommon.searchReviewIdea(
          this.searchForm,
          this.pageIndex,
          this.pageSize
        );
        this.submission = listSubmission.items;
        this.totals = listSubmission.totals;
      }
    }
  },
  methods: {
    checkPermissionFsuBu: helper.checkPermissionFsuBu,
    disabledTimeFrom(date) {
      if (this.ipSearchForm.requestedTimeTo) {
        return date > this.ipSearchForm.requestedTimeTo;
      }
    },
    disabledTimeTo(date) {
      return date < this.ipSearchForm.requestedTimeFrom;
    },
    redirect: function(href) {
      window.location.href = href;
    },
    showDateSearch() {
      $("#dropdownMenuButton").show();
    },
    hideDateSearch() {
      $("#dropdownMenuButton").hide();
    },
    displayDateSearch: function() {
      if (this.checkDate == "submit") {
        this.allDate = "";
        this.displayDate =
          "Submitted Time:" +
          this.formatDateTime(this.ipSearchForm.submitedTimeFrom) +
          " to " +
          this.formatDateTime(this.ipSearchForm.submitedTimeTo);
      }
      if (this.checkDate == "ass") {
        this.allDate = "";
        this.displayDate =
          "Assigned Time:" +
          this.formatDateTime(this.ipSearchForm.assignedDateFrom) +
          " to " +
          this.formatDateTime(this.ipSearchForm.assignedDateTo);
      }
      if (this.checkDate == "publish") {
        this.allDate = "";
        this.displayDate =
          "Published Time:" +
          this.formatDateTime(this.ipSearchForm.publishedTimeFrom) +
          " to " +
          this.formatDateTime(this.ipSearchForm.publishedTimeTo);
      }
    },
    fetchCompany() {
      axios
        .get(CONFIG.API_URL + "/company/search?pageNo=1&pageSize=1000")
        .then(res => {
          if (res.data && res.data.data.items) {
            this.companys = res.data.data.items;
          }
        });
    },
    fuseSearch(options, search) {
      return search.length ? fuse.search(search) : fuse.list;
    },

    clearFilterSearch: function() {
      this.allDate = "all";
      this.ipSearchForm.title = "";
      this.ipSearchForm.author = "";
      this.ipSearchForm.type = null;
      this.ipSearchForm.status = "";
      this.comboBox.reviewer = "";
      this.comboBox.companyCode = "";
      this.comboBox.status = "";
      this.comboBox.ipType = "";
      this.searchSubmission(true);
    },
    clearComboBoxUser: function() {
      this.comboBox.reviewerAss = "";
    },

    clearDate: function() {
      this.ipSearchForm.assignedDateFrom = "";
      this.ipSearchForm.assignedDateTo = "";
      this.ipSearchForm.publishedTimeFrom = "";
      this.ipSearchForm.publishedTimeTo = "";
      this.ipSearchForm.submitedTimeFrom = "";
      this.ipSearchForm.submitedTimeTo = "";
      this.checkDate = "";
      this.displayDate = "All Date";
    },
    filterSubmit: function() {
      this.ipSearchForm.companyCode = this.comboBox.companyCode
        ? this.comboBox.companyCode
        : null;
      if (this.comboBox.reviewer && this.comboBox.reviewer.length > 0) {
        this.comboBox.reviewer.forEach(r => {
          this.ipSearchForm.reviewer += r.account + ",";
        });
      } else {
        this.ipSearchForm.reviewer = "";
      }
    },
    insertAssignedReviewer: function(id) {
      let errorAddRole = document.getElementsByClassName("error1");
      var list = new Array();
      if (
        this.comboBox.reviewerAss == null ||
        this.comboBox.reviewerAss == ""
      ) {
        errorAddRole[0].style.display = "-webkit-box";
      } else {
        let btnSaveRole = document.getElementById("btn-save");
        btnSaveRole.setAttribute("data-dismiss", "modal");
        if (this.comboBox.reviewerAss != null) {
          this.comboBox.reviewerAss.forEach(r => {
            var object = {
              contentId: id,
              groupId: 1,
              userName: r.account,
              type: "user"
            };

            list.push(object);
          });
        }
      }
      this.axios
        .post(`${CONFIG.API_URL}/review-submission/insert`, list)
        .then(rest => {
          this.message.assign = rest.data.message[0].msg;
          helper.successMsg(this.message.assign);
          this.searchSubmission(true);
        })
        .catch(err => {});
    },
    setSelected: function(reviewer, id) {
      this.comboBox.reviewerAss = [];
      if (reviewer != null) {
        var split = reviewer.split(",");
        let selectedObj = [];
        split.forEach(s => {
          var object = {
            account: s
          };
          selectedObj.push(object);
        });
        this.comboBox.reviewerAss = selectedObj;
      }
    },
    formatDateTime: function(time) {
      if (time != null) {
        return moment(time).format("YYYY-MM-DD");
      }
      return "";
    },

    getMasterDataByType: function(type, target) {
      masterDataCommon.getByType(type).then(res => {
        this.masterData[target] = res.data.data.items;
      });
    },
    deleteSubmission: function(id) {
      this.axios
        .put(`${CONFIG.API_URL}/review-submission?id=${id}`)
        .then(rest => {
          this.delete = rest.data.message[0].msg;
          helper.successMsg(this.delete);
          this.searchSubmission(true);
        })
        .catch(err => {
          console.error(err);
        });
    },
    getAllReviewer: function() {
      this.axios
        .get(`${CONFIG.API_URL}/review-submission/reviewer`)
        .then(rest => {
          this.reviewer = rest.data.data;
        })
        .catch(err => {
          console.error(err);
        });
    },
    exportReviewSubmissionExcel: function() {
      this.loadingExport = true;
      this.filterSubmit();
      this.axios
        .post(`${CONFIG.API_URL}/review-submission/export`, this.ipSearchForm, {
          responseType: "blob"
        })
        .then(res => {
          const headers = res.headers;
          const blob = new Blob([res.data], { type: headers["content-type"] });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "ExcelReviewSubmission.xls";
          link.click();
          this.loadingExport = false;
        })
        .catch(err => {
          console.error(err);
        });
    },
    searchSubmission: function(applyCheck) {
      // if (
      //   this.ipSearchForm.submitedTimeFrom > this.ipSearchForm.submitedTimeTo &&
      //   this.ipSearchForm.submitedTimeTo != ""
      // ) {
      //   helper.errMsg(
      //     "Submitted time from can be greater than Submitted time to!"
      //   );
      //   return;
      // }
      // if (
      //   this.ipSearchForm.assignedDateFrom > this.ipSearchForm.assignedDateTo &&
      //   this.ipSearchForm.assignedDateTo != ""
      // ) {
      //   helper.errMsg(
      //     "Assgined time from can be greater than Submitted time to!"
      //   );
      //   return;
      // }
      // if (
      //   this.ipSearchForm.publishedTimeFrom >
      //     this.ipSearchForm.publishedTimeTo &&
      //   this.ipSearchForm.publishedTimeTo != ""
      // ) {
      //   helper.errMsg(
      //     "Published time from can be greater than Submitted time to!"
      //   );
      //   return;
      // }
      this.loading = true;
      if (applyCheck) {
        this.pageIndex = 1;
      }

      this.filterSubmit();

      ideaCommon
        .searchReviewIdea(this.ipSearchForm, this.pageIndex, this.pageSize)
        .then(res => {
          this.submission = res.items;
          this.total = res.totals;
          this.loading = false;
          // this.ipSearchForm.reviewer = "";
        })
        .catch(error => {
          this.submission = [];
          this.total = 0;
          this.loading = false;
        });
    },
    disabledSubmitedTimeFrom(date) {
      if (this.ipSearchForm.submitedTimeTo) {
        return date > this.ipSearchForm.submitedTimeTo;
      }
    },
    disabledSubmitedTimeTo(date) {
      return date < this.ipSearchForm.submitedTimeFrom;
    },
    disabledAssignedDateFrom(date) {
      if (this.ipSearchForm.assignedDateTo) {
        return date > this.ipSearchForm.assignedDateTo;
      }
    },
    disabledAssignedDateTo(date) {
      return date < this.ipSearchForm.assignedDateFrom;
    },
    disabledPublishedTimeFrom(date) {
      if (this.ipSearchForm.publishedTimeTo) {
        return date > this.ipSearchForm.publishedTimeTo;
      }
    },
    disabledPublishedTimeTo(date) {
      return date < this.ipSearchForm.publishedTimeFrom;
    },
    getClassCICD(status) {
      if (status === "SUCCESS") {
        return "fa fa-check-circle text-success";
      }
      if (status === "FAILURE") {
        return "fa fa-times-circle text-danger";
      }
      if (status === "IN PROGRESS") {
        return "fa fa-spinner text-info";
      }
      if (status === "PENDING") {
        return "fa fa-clock-o text-warning";
      }
      return "";
    }
  },
  computed: {
    resultIndexBeg() {
      return this.pageIndex * this.pageSize - this.pageSize + 1;
    },
    resultIndexEnd() {
      return (
        this.pageIndex * this.pageSize - this.pageSize + this.submission.length
      );
    }
  },
  async mounted() {
    this.fetchCompany();
    this.masterData.type = ipType;
    this.listStatus = await masterDataCommon.sync.getByTypeAndCodeIn(
      "idea_status",
      ["submit", "request_update", "preliminary_examination"]
    );
    this.listType = await masterDataCommon.sync.getByType("idea_type");
    let listSubmission = await ideaCommon.searchReviewIdea(
      this.searchForm,
      this.pageIndex,
      this.pageSize
    );
    this.submission = listSubmission.items;
    this.total = listSubmission.totals;
  }
};
$(".dropdown-menu").click(function(e) {
  e.stopPropagation();
});
</script>

<style  scoped>
@import "../../assets/css/filter_customs.css";
@import "../../assets/css/table_customs.css";

.modal-body form > .row {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: right;
}
.required:after {
  content: " * ";
  color: red;
}
div .errortemp {
  color: red;
  display: inline-block;
  margin-left: 5px;
}

@media (min-width: 992px) {
  .modal-lg {
    max-width: 650px !important;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/pages/ReviewSubmission.vue